import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSession } from "@/context/SessionContext";

export default function NotProvisioned() {
  const { me, logout } = useSession();
  const inactive = me?.status === "inactive";
  return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="not-provisioned-page">
      <div className="g39-card max-w-md w-full p-8 text-center g39-rise">
        <ShieldAlert className="h-8 w-8 text-gold mx-auto mb-4" />
        <h1 className="text-xl font-bold">{inactive ? "Account deactivated" : "Awaiting access"}</h1>
        <p className="text-sm text-muted-foreground mt-2">
          {inactive
            ? "Your Garage39 account has been deactivated. Contact your company administrator."
            : <>You're signed in as <b>{me?.user?.email || "this account"}</b>, but no company has granted you access yet. Ask your Garage39 administrator to add this email.</>}
        </p>
        <Button className="mt-6" variant="outline" onClick={logout} data-testid="not-provisioned-sign-out">Sign out</Button>
      </div>
    </div>
  );
}
